import { src } from '@data'
import { getHospitalName } from '@util'
import { Collapse, Expand, HospitalIcon } from '@icons'
import { useProfile, useSidebarStore } from '@zustore/store'
import { Avatar, Box, Text } from 'grommet'

export const SidebarHeader = () => {
  const { collapsed, toggleSidebar, expand, collapse } = useSidebarStore()
  const { facility } = useProfile()
  const displayName = process.env.REACT_APP_HOSPITAL_NAME || facility?.name || 'Facility'
  const campusName = facility?.name && process.env.REACT_APP_HOSPITAL_NAME ? facility.name : null

  return (
    <Box align="center" className="relative" gap={collapsed ? '10px' : '30px'} pad={{ horizontal: '24px' }}>
      <div
        className="hidden lg:block absolute right-0 -top-2 rotate-180 cursor-pointer"
        onClick={collapsed ? expand : collapse}
      >
        {collapsed && <Collapse />}
        {!collapsed && <Expand />}
      </div>
      <Text
        className={`sidebar-title${collapsed ? ' collapsed' : ''}`}
        onClick={toggleSidebar}
        style={{
          cursor: 'pointer',
          fontSize: collapsed ? '13px' : '28px',
          transition: 'font-size 0.3s'
        }}
      >
        AccessEMR
      </Text>
      <div
        className={`w-full flex-row items-center gap-2 rounded-md border border-dashed px-3 py-[7px] transition-all duration-300 ${collapsed ? 'hidden' : 'flex'}`}
      >
        <HospitalIcon />
        <div className="flex min-w-0 flex-1 flex-col items-start text-left">
          <p className="line-clamp-2 break-words text-sm font-medium leading-snug" title={displayName}>
            {displayName}
          </p>
          {campusName ? (
            <p className="line-clamp-1 break-words text-[10px] text-[#eeeeee]" title={campusName}>
              {campusName}
            </p>
          ) : null}
        </div>
      </div>
    </Box>
  )
}

export const UserSidebarHeader = () => {
  const { collapsed, toggleSidebar, expand, collapse } = useSidebarStore()
  const { user } = useProfile()
  return (
    <Box align="center" className="relative" gap={collapsed ? '10px' : '30px'} pad={{ horizontal: '24px' }}>
      <Box className="absolute right-0 -top-2 rotate-180 cursor-pointer" onClick={collapsed ? expand : collapse}>
        {collapsed && <Collapse />}
        {!collapsed && <Expand />}
      </Box>
      <Text
        className={`sidebar-title${collapsed ? ' collapsed' : ''}`}
        onClick={toggleSidebar}
        style={{
          cursor: 'pointer',
          fontSize: collapsed ? '13px' : '28px',
          transition: 'font-size 0.3s'
        }}
      >
        AccessEMR
      </Text>
      <Box align="center" gap={collapsed ? '0px' : '10px'}>
        <Avatar size={collapsed ? '40px' : '80px'} src={src} style={{ transition: 'all 0.3s' }} />
        {!collapsed && (
          <Box direction="row" gap="small" pad={{ horizontal: 'medium' }}>
            <Box align="center" direction="column">
              <Text size="small" style={{ maxWidth: '120px', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} truncate>
                {user?.first_name} {user?.last_name}
              </Text>
              <Text
                margin={{ bottom: 'xsmall' }}
                size="12px"
                style={{
                  display: '-webkit-box',
                  maxWidth: '140px',
                  overflow: 'hidden',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                  overflowWrap: 'break-word',
                  textAlign: 'center'
                }}
                title={getHospitalName()}
              >
                {getHospitalName()}
              </Text>
              <Text color="asparagus" size="12px">
                View profile
              </Text>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}
